import { Attribute, AttributePropertyValues, IAttribute } from "../System.Runtime/Attribute";
import { NAMESPACE } from "./_Namespace";

export type ClientAwarePropertyInfoAttributePropertyValues =
    AttributePropertyValues
    & {
        classHierarchyDepth: number;
    };

export type ClientAwarePropertyInfoAttributeProperties = {
    [name in keyof ClientAwarePropertyInfoAttributePropertyValues]?: ClientAwarePropertyInfoAttributePropertyValues[name];
};

export interface IClientAwarePropertyInfoAttribute extends IAttribute, ClientAwarePropertyInfoAttributeProperties
{
}

export class ClientAwarePropertyInfoAttribute extends Attribute implements IClientAwarePropertyInfoAttribute
{
    public static override classNamespace = NAMESPACE + "ClientAwarePropertyInfoAttribute";
    public static override className = "ClientAwarePropertyInfoAttribute";

    public classHierarchyDepth?: number;

    constructor(propertyValues?: Partial<ClientAwarePropertyInfoAttributePropertyValues>)
    {
        super(propertyValues);

        this.classHierarchyDepth = propertyValues?.classHierarchyDepth;
    }
}